import { StreamPlayState } from '../types/stream-play-models.type';
import { StreamPlayPagingData, StreamPlayResponse } from '../types/stream-play-api.type';

export class StreamPlayStoreUtils {

  /**
   * Consumes the state and return no more data state. (reducer)
   * @param streamPlayState Stream Play existing state
   *
   * @see StreamPlayState
   */
  public static setStreamPlayStateNoMoreData(streamPlayState: StreamPlayState): StreamPlayState {
    return {
      data: (streamPlayState.data)
          ? streamPlayState.data
          : [],
      paginationData: streamPlayState.paginationData && streamPlayState.paginationData,
    };
  }

  /**
   * Consumes the state and returns a state with updated data. (reducer)
   * @param streamPlayState Stream Play existing state
   * @param streamPlayResponse Stream Play API response
   * @param appendData If true, it will merge the existing data with the one retrieved from the response.
   *
   * @see StreamPlayState
   * @see StreamPlayResponse
   */
  public static setStreamPlayStateAndAppendData(
      streamPlayState: StreamPlayState,
      streamPlayResponse: StreamPlayResponse,
      appendData?: boolean,
  ): StreamPlayState {

    const {fixtures, ...paginationData} = streamPlayResponse;

    return {
      data: (appendData && streamPlayState?.data)
          ? [
            ...streamPlayState.data,
            ...fixtures,
          ]
          : fixtures,
      paginationData,
    };
  }

  /**
   * Gets the paging data from the state. (selector)
   * @param streamPlayState Stream Play existing state
   *
   * @see StreamPlayState
   * @see StreamPlayPagingData
   */
  public static getPagingDataFromStreamPlayState(streamPlayState: StreamPlayState): StreamPlayPagingData | null {
    return (streamPlayState && streamPlayState.paginationData)
        ? streamPlayState.paginationData
        : null;
  }
}
